import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { type DimKey } from '../../state/rates-filter-panel.service';

@Component({
  selector: 'app-applied-filter-row',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './applied-filter-row.component.html',
  styleUrl: './applied-filter-row.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppliedFilterRowComponent {
  @Input({ required: true }) dim!: DimKey;
  @Input({ required: true }) dimLabel!: string;
  @Input({ required: true }) valueSummary!: string;
  @Input() count: number | null = null;
  @Input() pinned = false;
  @Input() variant: 'active' | 'pinned-inactive' = 'active';

  @Output() rowClick = new EventEmitter<{ dim: DimKey; el: HTMLElement }>();

  @ViewChild('rowBtn', { static: true }) rowBtn!: ElementRef<HTMLButtonElement>;

  onClick(): void {
    this.rowClick.emit({ dim: this.dim, el: this.rowBtn.nativeElement });
  }
}
